export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5466.cf799409.jpg";